
interface FooterProps {
  onQuoteClick: () => void;
  onContactClick: () => void;
}

export default function Footer({ onQuoteClick, onContactClick }: FooterProps) {
  return (
    <>
      <footer className="bg-gray-900 text-white pb-20 md:pb-0">
        <div className="py-12 border-t border-gray-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div>
                <div className="mb-4 flex items-center gap-4">
                  <img 
                    src="https://www.inforesta.com/lp/image/6219bf22566b2c48557716b7afdebdfb.jpeg" 
                    alt="インフォレスタ" 
                    className="h-16 w-auto"
                  />
                  <img 
                    src="https://www.inforesta.com/lp/image/cddd3756def19d56959f88c92daf06cb.png" 
                    alt="ISO/IEC 27001:2022認証" 
                    className="h-16 w-auto object-contain"
                  />
                </div>
                <p className="text-gray-400 text-sm font-semibold mb-2">
                  株式会社インフォレスタ
                </p>
                <p className="text-gray-400 text-sm leading-relaxed mb-3">
                  〒113-0033<br />
東京都文京区本郷1-34-1 シャリエ本郷2F
                </p>
                <a 
                  href="https://www.inforesta.com/top/privacy-landing-page/?_gl=1*1bs5gn*_gcl_au*NjE0NzM5NjYxLjE3NjM2ODU5OTA.*_ga*NjU5OTg4MTkzLjE3NjM2ODU5OTA.*_ga_2Y7CSGBBDY*czE3NjM2OTMyOTkkbzIkZzEkdDE3NjM2OTMzMDAkajU5JGwwJGgw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  プライバシーポリシー
                </a>
                <a 
                  href="https://www.inforesta.com/top/description/?_gl=1*bkq0i*_gcl_au*NjE0NzM5NjYxLjE3NjM2ODU5OTA.*_ga*NjU5OTg4MTkzLjE3NjM2ODU5OTA.*_ga_2Y7CSGBBDY*czE3NjM2OTMyOTkkbzIkZzEkdDE3NjM2OTMzMDAkajU5JGwwJGgw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer mt-2 block"
                >
                  特定商取引法に基づく表記
                </a>
              </div>
              
              <div>
                <h4 className="font-bold mb-4">お問い合わせ</h4>
                <ul className="space-y-2 text-sm text-gray-400">
                  <li className="flex items-center gap-2">
                    <i className="ri-phone-line"></i>
                    <span>03-6858-8839</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    <span>月～金(土日祝除く)9:00～17:30</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-global-line"></i>
                    <a 
                      href="https://www.inforesta.com/index.php" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      https://www.inforesta.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
              <p>© 2025 株式会社インフォレスタ</p>
              <div className="flex items-center gap-6">
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Fixed CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-blue-600 shadow-2xl z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 md:py-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6">
            <button 
              onClick={onQuoteClick}
              className="w-full md:w-auto group bg-white text-blue-600 px-6 md:px-10 py-3 md:py-4 rounded-xl font-bold text-base md:text-lg hover:bg-blue-50 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-file-list-3-line"></i>
              無料見積もりを依頼する
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </button>
            <button 
              onClick={onContactClick}
              className="w-full md:w-auto bg-blue-700 text-white px-6 md:px-10 py-3 md:py-4 rounded-xl font-bold text-base md:text-lg border-2 border-white hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-chat-3-line"></i>
              お問い合わせはこちら
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
